import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const AUTH_ENTRY = ["/auth/login", "/auth/google/session"];

// Session ended (logout elsewhere, inactivity, password reset): clear it and go to sign-in.
export function handleSignedOut(detail) {
  if (!localStorage.getItem("token")) return;
  localStorage.removeItem("token");
  sessionStorage.setItem("signout_reason", detail || "Your session ended. Please sign in again.");
  if (window.location.pathname !== "/login") window.location.assign("/login");
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !AUTH_ENTRY.some((p) => url.includes(p))) {
      handleSignedOut(err.response.data?.detail);
    }
    return Promise.reject(err);
  }
);

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}
